import {registerStatsTestCleanup} from './test-cleanup'

const statsAccumulators = new Map<() => void, () => void>()
let scheduleStats: (() => void) | undefined

registerStatsTestCleanup(() => {
  for (const discard of statsAccumulators.values()) discard()
})

export function setStatsDeliveryScheduler(schedule: () => void): void {
  scheduleStats = schedule
}

export function registerStatsAccumulator(flush: () => void, discard: () => void): () => void {
  statsAccumulators.set(flush, discard)
  return () => {
    statsAccumulators.delete(flush)
  }
}

export function flushStatsAccumulators() {
  for (const flush of statsAccumulators.keys()) flush()
}

/** Notify the stats sender that accumulated values are ready for its next delivery. */
export function requestStatsDelivery(): void {
  scheduleStats?.()
}
